<template>
<div class="chapter">
<div class="inner_page">
<p><a id="ack"></a></p>
<div class="fmhT"><b>ACKNOWLEDGMENTS</b></div>
<div class="fmtx1">We would like to extend our heartfelt thanks and gratitude to Norm McMillan and Sid Doolittle, our teachers, mentors, and guides, who continue to provide the heart and soul of McMillan|Doolittle’s retail practice. We would also like to thank Eddie Baeb, former retail reporter for <i>Crain’s Chicago Business</i> and current staff writer for Bloomberg News, for his invaluable assistance in shaping the content and tone of the book and for conducting much of the background research that shaped the foundation. We would like to thank the extended family of current and past McMillan|Doolittle partners, affiliates, and clients for providing many of the thoughts, examples, and ideas that form the foundation of this book. And special thanks to Felicia Glinstra and Alison Perkins for helping to develop the data and charts and for generally putting up with us during the process of writing this book.</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ande_9781118039977_oeb_ack_r1.vue?59656218